import GoalTemplatesTable from "@components/GoalTemplatesTable";
import ExpertTablesPage from "@components/pageTypes/ExpertTablesPage";
import PageTitle from "@components/text/PageTitle";

const ExpertGoalTemplatesPage = () => (
  <ExpertTablesPage helmetKey="pageTitles.expert.goalTemplate.list">
    <PageTitle imageName="womanPlan" titleKey="pages.expert.goalTemplates.title" />
    <GoalTemplatesTable />
  </ExpertTablesPage>
);

export default ExpertGoalTemplatesPage;
